// Small action/export/import routes. Only app.quotes.$id.duplicate.tsx and
// app.quotes.import.tsx have merchant-facing strings beyond the shared
// `common.errors.*` keys — app.quotes.$id.counter.tsx, app.quotes.bulk-cancel.tsx,
// and app.quotes.export.tsx render nothing but "Shop not initialized" /
// "Not found" (reused from common.errors), so they have no sub-namespace here.
export const quoteMisc = {
  duplicate: {
    internalNotePrefix: "Duplicated from quote {{number}}.",
  },
  import: {
    heading: "Bulk-import quotes",
    step1: {
      heading: "Step 1 — Upload a CSV",
      intro:
        "One row per line item. Multiple rows with the same {{column}} collapse into one quote. We'll validate against your Shopify catalog when you confirm — bad rows are skipped.",
      requiredColumnsLabel: "Required columns:",
      optionalColumnsLabel: "Optional:",
    },
    errors: {
      tierRequired: "STARTER tier or higher required.",
      emptyFile: "Upload a non-empty CSV file.",
      fileTooLarge: "File exceeds {{mb}}MB limit.",
      noFile: "No file uploaded.",
      previewLost: "Re-upload the CSV — preview state was lost.",
      noValidQuotes: "No valid quotes to import.",
      tooManyQuotes: "Too many quotes in one import ({{count}} > {{max}}).",
    },
    parsingLabel: "Parsing…",
    previewLabel: "Preview",
    step2: {
      heading: "Step 2 — Preview ({{good}}, {{errors}})",
      goodOne: "{{count}} valid quote",
      goodOther: "{{count}} valid quotes",
      errorOne: "{{count}} row error",
      errorOther: "{{count}} row errors",
    },
    unknownHeadersBanner: "We didn't recognize these columns and ignored them:",
    lineCountOne: "{{count}} line",
    lineCountOther: "{{count}} lines",
    andMore: "… and {{count}} more",
    rowErrorsHeading: "Row errors ({{count}})",
    rowLabel: "Row {{number}}",
    step3: {
      heading: "Step 3 — Confirm",
      introOne:
        "About to create {{count}} quote. Each will be assigned a fresh internal number (Q-N) and the external reference is recorded in the internal note.",
      introOther:
        "About to create {{count}} quotes. Each will be assigned a fresh internal number (Q-N) and the external reference is recorded in the internal note.",
      importingLabel: "Importing…",
      importOne: "Import {{count}} quote",
      importOther: "Import {{count}} quotes",
      cancelUploadDifferent: "Cancel and upload a different file",
    },
  },
};
